/* RUEMOOD delivery dates (3 Nov 2026). One rule for every delivery statement on the site:
   arrival = today + 3 days to prepare the order + the destination's transit days, all counted as calendar days.
   Transit {min,max} comes from shop.metafields.ruemood.shipping_details (rendered into data-min / data-max).
   Output: "Order today, arrives 12–18 Nov"; across months "28 Nov – 4 Dec". Liquid prints the same text first
   (snippets/ruemood-delivery-dates.liquid); this file redraws it in the shopper's own time zone and when the
   destination in a product page's Shipping panel changes. Elements without valid transit stay hidden. */
(function () {
  'use strict';
  if (window.RuemoodDeliveryDates) return;
  var PREP_DAYS = 3;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function days(transit) {
    if (!transit) return null;
    var min = Number(transit.min), max = Number(transit.max);
    if (!isFinite(min) || !isFinite(max) || min < 0 || max < min || max > 90) return null;
    return {min: Math.round(min), max: Math.round(max)};
  }
  function addDays(base, n) {
    return new Date(base.getFullYear(), base.getMonth(), base.getDate() + n, 12, 0, 0, 0);
  }
  function range(transit, today) {
    var d = days(transit);
    if (!d) return '';
    var base = today || new Date();
    var a = addDays(base, PREP_DAYS + d.min), b = addDays(base, PREP_DAYS + d.max);
    if (d.min === d.max) return a.getDate() + ' ' + MONTHS[a.getMonth()];
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) return a.getDate() + '–' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
  }
  function line(transit, today) {
    var r = range(transit, today);
    return r ? 'Order today, arrives ' + r : '';
  }
  function transitText(transit) {
    var d = days(transit);
    if (!d) return '';
    return d.min === d.max ? d.min + (d.min === 1 ? ' day' : ' days') : d.min + '–' + d.max + ' days';
  }
  function breakdown(transit) {
    var t = transitText(transit);
    return t ? 'Includes ' + PREP_DAYS + ' days to prepare your order and ' + t + ' in transit.' : '';
  }
  function setText(root, selector, text) {
    root.querySelectorAll(selector).forEach(function (node) { node.textContent = text; });
  }

  /* [data-rm-delivery] element: data-min, data-max, optional data-country-name, data-note.
     Children it fills: [data-rm-delivery-range], [data-rm-delivery-line], [data-rm-delivery-breakdown],
     [data-rm-delivery-country], [data-rm-delivery-note]. */
  function draw(el, today) {
    var transit = el.dataset.min !== undefined && el.dataset.min !== '' ? {min: el.dataset.min, max: el.dataset.max} : null;
    var r = range(transit, today);
    el.hidden = !r;
    if (!r) return;
    setText(el, '[data-rm-delivery-range]', r);
    setText(el, '[data-rm-delivery-line]', 'Order today, arrives ' + r);
    setText(el, '[data-rm-delivery-breakdown]', breakdown(transit));
    if (el.dataset.countryName) setText(el, '[data-rm-delivery-country]', el.dataset.countryName);
    el.querySelectorAll('[data-rm-delivery-note]').forEach(function (node) {
      node.textContent = el.dataset.note || '';
      node.hidden = !node.textContent;
    });
  }
  function render(root) {
    var scope = root || document;
    var today = new Date();
    if (scope.matches && scope.matches('[data-rm-delivery]')) draw(scope, today);
    scope.querySelectorAll('[data-rm-delivery]').forEach(function (el) { draw(el, today); });
  }

  /* A product page's Shipping panel lets shoppers check another destination; elements marked
     data-rm-delivery-follow in the same product section show that destination too. The market and cart never change. */
  var configs = new WeakMap();
  function panelConfig(panel) {
    if (configs.has(panel)) return configs.get(panel);
    var config = null;
    try { config = JSON.parse(panel.querySelector('[data-shipping-config]').textContent); } catch (_) { config = null; }
    if (!config || config.schemaVersion !== 1) config = null;
    configs.set(panel, config);
    return config;
  }
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('select[data-shipping-country]')) return;
    var panel = select.closest('ruemood-shipping-details');
    var config = panel && panelConfig(panel);
    if (!config) return;
    var code = select.value;
    var transit = (config.transit || {})[code];
    var name = select.selectedOptions && select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : code;
    var scope = select.closest('product-info') || document;
    scope.querySelectorAll('[data-rm-delivery][data-rm-delivery-follow]').forEach(function (el) {
      var d = days(transit);
      el.dataset.country = code;
      el.dataset.countryName = name;
      el.dataset.min = d ? d.min : '';
      el.dataset.max = d ? d.max : '';
      el.dataset.note = (transit && transit.note) || '';
      draw(el, new Date());
    });
  });

  window.RuemoodDeliveryDates = Object.freeze({PREP_DAYS: PREP_DAYS, range: range, line: line, breakdown: breakdown, transitText: transitText, render: render});
  render(document);
  // Product swaps and late popups add new delivery lines; draw them as they arrive.
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('[data-rm-delivery]') || node.querySelector('[data-rm-delivery]')) render(node);
        });
      });
    }).observe(document.body, {childList: true, subtree: true});
  }
})();
